import { createContext, ReactNode, useContext, useState } from "react";

type UserContextProps = {
  userEmail: string | null;
  userId: number | null;
  hasUnsignedDocuments: boolean;
  hasExpiredPaymentMethods: boolean;
  setUserEmail: (userEmail: string | null) => void;
  setUserId: (userId: number | null) => void;
  setHasUnsignedDocuments: (hasUnsignedDocuments: boolean) => void;
  setHasExpiredPaymentMethods: (hasExpiredPaymentMethods: boolean) => void;
};

const UserContext = createContext<UserContextProps | undefined>(undefined);

export function UserProvider({
  children,
}: {
  children: ReactNode | ReactNode[];
}) {
  const [userEmail, setUserEmail] = useState<string | null>(null);
  const [userId, setUserId] = useState<number | null>(null);
  const [hasUnsignedDocuments, setHasUnsignedDocuments] =
    useState<boolean>(false);
  const [hasExpiredPaymentMethods, setHasExpiredPaymentMethods] =
    useState<boolean>(false);

  const contextValue = {
    userEmail,
    userId,
    hasUnsignedDocuments,
    hasExpiredPaymentMethods,
    setUserEmail,
    setUserId,
    setHasUnsignedDocuments,
    setHasExpiredPaymentMethods,
  };

  return (
    <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>
  );
}

export function useUserContext() {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error("useUserContext must be used within a UserProvider");
  }
  return context;
}
